export default "__VITE_ASSET__BTXlKoj5__"